const setData = (state, action) => {
  return { ...state, [action.model]: action.data };
};

const dataChanged = (state, action) => {
  return {
    ...state,
    [action.model]: { ...state[action.model], [action.field]: action.data },
  };
};

export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_FORM':
    case 'CLEAR_FORM':
      return setData(state, action);
    case 'FORM_DATA_CHANGED':
      return dataChanged(state, action);
    case 'LOGOUT':
      return {};
    default:
      return state;
  }
};
